import React, { Component } from 'react';
import Legend from './Legend';

import './Legends.scss';

const Legends = ({ legends, isVertical, ...props }) => (
  <div { ...props } className={`legends ${isVertical ? 'legends--vertical' : ''}`} >
    {
      legends.map((legend, index) => <Legend key={legend} legend={legend} index={index} />)
    }
  </div>
)

export default Legends;
